import { useDispatch } from "react-redux";
import type { OloStore } from "reducers/online_ordering/onlineOrdering";

export const useOloDispatch = useDispatch as () => OloStore["dispatch"];
